<template><div><dt-stack gap="600" class="d-mbs-600">
  <figure class="d-bar-500 d-of-hidden">
    <svg-loader name="icon--billboard" class="d-bar-500" />
  </figure>
  <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols3 d-ai-center">
    <div>
      <h2 class="d-docsite--header-3 d-mbs-0">Usage</h2>
      <p class="d-docsite--paragraph">For limited instances where space is restricted, use the shorthand icon mark.  </p>
      <p class="d-docsite--paragraph"><strong>Sample Use Cases</strong>: App icons, social avatars, favicons.</p>
    </div>
    <div class="d-gc2">
      <svg-loader name="icon--usage" class="d-bar-500" />
    </div>
  </div>
  <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols3 d-ai-center">
    <div>
      <h2 class="d-docsite--header-3 d-mbs-0">Versions</h2>
      <p class="d-docsite--paragraph">In most instances, the primary full brand gradient version should be used.</p>
      <p class="d-docsite--paragraph">The Meetings app icon should only be used when referencing the meetings app.</p>
      <p class="d-docsite--paragraph"><dt-link href="#">Download icons</dt-link></p>
    </div>
    <div class="d-gc2">
      <svg-loader name="icon--versions" class="d-bar-500" />
    </div>
  </div>
  <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols3 d-ai-center">
    <div>
      <h2 class="d-docsite--header-3 d-mbs-0">In Product</h2>
      <p class="d-docsite--paragraph">Use the icon as a logomark to identify the application in headers, as an app icon, or favicon.</p>
      <p class="d-docsite--paragraph"><dt-link href="#">View Dialtone Icon</dt-link></p>
    </div>
    <div class="d-gc2">
      <svg-loader name="icon--in-product" class="d-bar-500" />
    </div>
  </div>
  <figure class="d-bar-500 d-of-hidden">
    <img src="/assets/images/color--sample-01.jpg" alt="">
  </figure>
  <figure class="d-bar-500 d-of-hidden">
    <img src="/assets/images/color--sample-02.jpg" alt="">
  </figure>
  <figure class="d-bar-500 d-of-hidden">
    <img src="/assets/images/color--sample-03.jpg" alt="">
  </figure>
</dt-stack>
</div></template>


